import { render, staticRenderFns } from "./emarticonGuide.vue?vue&type=template&id=5d4e2387&scoped=true"
import script from "./emarticonGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./emarticonGuide.vue?vue&type=script&setup=true&lang=js"
import style0 from "./emarticonGuide.vue?vue&type=style&index=0&id=5d4e2387&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4e2387",
  null
  
)

export default component.exports